import {
  Box,
  Button,
  Grid,
  IconButton,
  Rating,
  Skeleton,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useMemo, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SkeletonLoader from "../../Components/Component/SkeletonLoader";
import { AppContext } from "../../Components/context/app.context";
import { CartContext } from "../../Components/context/cartContext";
import { FailurePop, SuccessPop } from "../../Components/Popup";
import SigninPop from "../Login/SigninPop";
import CartConfirmation from "../../Components/Component/CartConfirmation";
import { LastURL } from "../../Components/reducers/config";
import { useDispatch } from "react-redux";
import AddCar from "../../Components/Component/AddCar";

const WebsiteOffer = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const dispatch = useDispatch();

  /* useContext */
  const {
    total,
    signIn,
    CarList,
    carValue,
    cartList,
    offerTotal,
    openSignin,
    branchValue,
    fetchCartList,
    setOpenSignin,
  } = useContext(AppContext);
  const {
    productTax,
    productTotal,
    productSubTotal,
    productCartList,
    productOfferTotal,
    fetchProductCartList,
  } = useContext(CartContext);

  /* params value */
  const getId = new URLSearchParams(location.search).get("offerId");
  const get_id = getId ? atob(atob(getId)) : "";

  /* useState */
  const [loader, setLoader] = useState(false);
  const [offerList, setOfferList] = useState([]);
  const [couponDetails, setCouponDetails] = useState(null);
  const [applied, setApplied] = useState(false);
  const [content, setContent] = useState("");
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalFail, setModalFail] = useState(false);
  const [cartLoad, setCartLoad] = useState(false);
  const [openAddCar, setOpenAddCar] = useState(false);

  /* Service */
  const [openCartConfirm, setOpenCartConfirm] = useState(false);
  const [selectedService, setSelectedService] = useState([]);

  /* Functions */

  const handleNavigation = (type) => {
    if (type === "Service") {
      Navigate("/app/booking/slot", {
        state: { data: cartList },
      });
    } else if (type === "Product") {
      Navigate("/app/productpayment", {
        state: {
          data: productCartList,
          otherData: {
            subTotal: productSubTotal,
            tax: productTax,
            actualPrice: productTotal,
            locationPath: "cart",
          },
        },
      });
    }
  };

  /* Service Functions */
  const serviceCartValidate = async () => {
    if (CarList?.length == 0) {
      setContent("Please Add Your Car");
      setModalFail(true);

      setOpenAddCar(true);

      setTimeout(() => {
        setModalFail(false);
      }, 1500);
      return true;
    }

    if (!carValue?.reg_number) {
      setContent("Please Choose a Car");
      setModalFail(true);

      setTimeout(() => {
        setModalFail(false);
      }, 1500);
      return true;
    }
    if (cartList?.length > 0) {
      let matchType = offerList?.find((e) => e?.type !== cartList[0]?.type);

      if (matchType) {
        setOpenCartConfirm(true);
        setSelectedService(offerList);
      } else {
        const serviceIds = offerList?.map((x) => x._id);
        let matchService = cartList?.filter((e) =>
          serviceIds?.includes(e?.service_id?._id)
        );

        console.log("matchService", matchService);

        if (matchService?.length > 0) {
          await Promise.all(matchService.map((item) => RemoveCart(item._id)));
          await Promise.all(
            offerList?.map((item, index) => AddtoCart(item, index))
          );
        } else {
          addFunction(offerList);
        }
      }
    } else {
      await Promise.all(
        offerList?.map((item, index) => AddtoCart(item, index))
      );
    }
  };

  const addFunction = async (data) => {
    await Promise.all(data?.map((item, index) => AddtoCart(item, index)));
  };

  const AddtoCart = async (data, i) => {
    setCartLoad(true);
    try {
      const findId = data?.service_group_id;

      const payload = {
        customer_id: global.$userData.id,
        service_id: data?._id,
        group_id: findId || "",
        cat_id: data?.service_cat_id,
        subcat_id: data?.service_subcat_id,
        price_id: data?.price_id,
        price: data?.price, //995 - 200 =795
        actualPrice: data?.actual_price, //700
        taxPercentage: data?.taxPercentage,
        brand_id: carValue?.brand_id?._id,
        model_id: carValue?.model_id?._id,
        type_id: carValue?.type_id?._id,
        size_id: carValue?.size_id?._id,
        year: carValue?.year,
        reg_number: carValue?.reg_number,
        type: data?.type === "amcService" ? "amcService" : "regular",
        taxAmount: data?.tax_amount, //295 = 995
        // special_id: routeData?.is_offer_applied,
        offer_amount: data?.coupon_amount,
        discounted_price: data?.discounted_price,
        coupon_id: couponDetails?._id,
      };
      const response = await global.$axios.post("cart/addToCart", payload);
      if (response.data.status == "success") {
        await fetchCartList();
        if (offerList?.length - 1 === i) {
          setContent("Added To Cart");
          setModalSuccess(true);
          setCartLoad(false);
          setTimeout(() => {
            findMatch(couponDetails);
          }, 300);
        }
      } else {
        console.log("Add Cart Something Went Wrong", response.data);
      }
    } catch (error) {
      console.log("Add To Cart Issue", error);
    }
  };

  const RemoveCart = async (id) => {
    try {
      const response = await global.$axios.post("cart/deleteCart", {
        cart_id: id,
      });
      if (response.data.status == "success") {
        await fetchCartList();
      } else {
        console.log("Remove Cart Issue", response.data);
      }
    } catch (error) {
      console.log("Remove Cart Issue", error);
    }
  };

  /* Product Functions */

  const cartValidate = async () => {
    if (!signIn) {
      setOpenSignin(true);
      return true;
    }
    if (offerList?.length > 0) {
      setCartLoad(true);
      await Promise.all(
        offerList.map((item, index) => AddProductCart(item, index))
      );
    }
  };

  const AddProductCart = async (item, i) => {
    try {
      const data = {
        customer_id: global.$userData.id,
        product_id: item?._id,
        product_subcat_id: item?.product_subcat_id,
        price: item?.customer_price,
        user_id: global.$userData.id,
        actual_price: item?.actual_price,
        tax_percentage: branchValue?.tax_type?.tax,
        taxAmount: item?.tax_amount,
        quantity: 1,
        offer_amount: item?.offer_amount,
        coupon_id: couponDetails?._id,
        discounted_price: item?.discounted_price,
        increment: false,
      };

      console.log("data", data);

      const response = await global.$axios.post("product/addCart", data);
      if (response.data.status === "success") {
        await fetchProductCartList();

        if (offerList?.length - 1 === i) {
          setContent("Added To Cart");
          setModalSuccess(true);
          setCartLoad(false);
          setTimeout(() => {
            findMatch(couponDetails);
          }, 300);
        }
      } else {
        console.log("Product Add to cart Issue", response.data.message);
        setContent("Something Went Wrong, Try Again!");
        setModalFail(true);
        setCartLoad(false);
      }
    } catch (error) {
      console.log("Product Add to cart Issue", error);
      setCartLoad(false);
    }
  };

  /* Child Components */
  const AMCItem = ({ offerList }) => {
    return (
      <React.Fragment>
        {offerList?.length > 0 ? (
          offerList?.map((amc, index) => {
            return (
              <Grid
                key={index + 1}
                item
                xs={12}
                sm={4}
                md={3}
                xl={2}
                sx={{
                  boxShadow: 2,
                  borderRadius: 2,
                  p: 1,
                }}
              >
                <Grid sx={{ height: "20vh" }}>
                  <Box
                    component="img"
                    sx={{
                      height: "100%",
                      width: "100%",
                      borderRadius: 2,
                      objectFit: "contain",
                      boxShadow: 2,
                    }}
                    alt="5k Car Care"
                    src={
                      amc?.service_id?.service_image ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdaOuISNPK0h-pbCWSRXVlLG6YrOr4MdXanw&s"
                    }
                  />
                </Grid>

                <Grid
                  sx={{
                    mt: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Grid sx={{ display: "flex", alignItems: "center" }}>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        textDecoration: "line-through",
                      }}
                    >
                      <CurrencyRupeeIcon fontSize="xs" sx={{ fontSize: 12 }} />
                      <Typography sx={{ fontSize: 12 }}>
                        {amc?.price_tire || "0"}
                      </Typography>
                    </Grid>

                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      <CurrencyRupeeIcon fontSize="xs" />
                      <Typography sx={{ fontSize: 16 }}>
                        {amc?.discounted_price || "0"}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Typography
                    noWrap={false}
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: {
                        xs: 2,
                        md: 1,
                      } /* number of lines */,
                      WebkitBoxOrient: "vertical",
                      fontWeight: "bold",
                    }}
                  >
                    <Tooltip title={amc?.name} arrow>
                      {amc?.name}
                    </Tooltip>
                  </Typography>

                  <div style={{ fontWeight: 500, color: "#071CB7" }}>{` for ${
                    amc?.no_of_year_days || "1"
                  } ${
                    amc?.is_year
                      ? amc?.no_of_year_days > 1
                        ? "years"
                        : "year"
                      : amc?.no_of_year_days
                      ? "days"
                      : "year"
                  }  ${amc?.pickUp_type ? "with free pickup" : ""}`}</div>
                </Grid>

                <Grid
                  container
                  sx={{
                    background: "#071CB720",
                    px: 1,
                    py: 0.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderTopRightRadius: 5,
                    borderTopLeftRadius: 5,
                    mt: 1,
                  }}
                >
                  <div>Included Services</div>
                  <IconButton
                  // onClick={() => setSelected(!selected)}
                  >
                    {true ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </IconButton>
                </Grid>
                {/* {selected && ( */}
                <Grid
                  sx={{
                    background: "#071CB720",
                    p: 1,
                    borderTop: "1px solid #C2C2C2",
                    height: "20vh",
                    overflowY: "auto",
                    borderBottomRightRadius: 5,
                    borderBottomLeftRadius: 5,
                  }}
                >
                  {amc?.services?.map((child, index) => {
                    return (
                      <div
                        key={index + 1}
                        style={{
                          margin: "5px 0px",
                          boxShadow: "10px",
                          background: "#FFF",
                          padding: "5px",
                          borderRadius: "5px",
                        }}
                      >
                        <div>{child?.service_id?.name}</div>
                        <div style={{ fontSize: 14, color: "#071CB7" }}>
                          {`upto ${child?.service_count} for free`}
                        </div>
                      </div>
                    );
                  })}
                </Grid>
                {/* )} */}
                <Grid container sx={{ mt: 1 }}>
                  <Button
                    variant="contained"
                    sx={{
                      width: "100%",
                      background: "#071CB7",
                    }}
                    onClick={() => {
                      if (!signIn) {
                        setOpenSignin(true);
                        return true;
                      }
                      if (!carValue?.reg_number) {
                        setOpenAddCar(true);
                        return true;
                      }
                      Navigate("/app/amcPlanPayment", {
                        state: {
                          data: amc,
                          is_renew: false,
                          couponData: couponDetails,
                        },
                      });
                    }}
                  >
                    Buy Now
                  </Button>
                </Grid>
              </Grid>
            );
          })
        ) : (
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 20,
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: 25 }}>
              No AMC Plan Found
            </Typography>
          </Grid>
        )}
      </React.Fragment>
    );
  };

  const ProductItem = ({ offerList }) => {
    return (
      <React.Fragment>
        {offerList?.length > 0 ? (
          offerList?.map((product, index) => {
            return (
              <Grid
                key={index + 1}
                item
                xs={12}
                sm={3}
                xl={2}
                sx={{
                  boxShadow: 2,
                  borderRadius: 2,
                  p: 1,
                }}
              >
                <Grid sx={{ height: "20vh" }}>
                  <Box
                    component="img"
                    sx={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    alt="5k Car Care"
                    src={
                      product?.image
                        ? product?.image
                        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdaOuISNPK0h-pbCWSRXVlLG6YrOr4MdXanw&s"
                    }
                  />
                </Grid>
                <Grid
                  sx={{
                    mt: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Grid sx={{ display: "flex", alignItems: "center" }}>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        textDecoration: "line-through",
                      }}
                    >
                      <CurrencyRupeeIcon fontSize="xs" />
                      <Typography>{product?.actual_price || "0"}</Typography>
                    </Grid>

                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      <CurrencyRupeeIcon fontSize="xs" />
                      <Typography>
                        {product?.discounted_price
                          ? product?.discounted_price
                          : "0"}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Typography
                    noWrap={false}
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: {
                        xs: 2,
                        md: 1,
                      } /* number of lines */,
                      WebkitBoxOrient: "vertical",
                      fontWeight: "bold",
                    }}
                  >
                    <Tooltip title={product?.name} arrow>
                      {product?.name}
                    </Tooltip>
                  </Typography>
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",

                      gap: 1,
                    }}
                  >
                    <Typography sx={{ pt: 0.5, fontSize: 14 }}>
                      {product?.rating || 5}
                    </Typography>
                    <Rating
                      name="half-rating-read"
                      precision={0.5}
                      value={product?.rating || 5}
                      readOnly
                      size="small"
                    />
                  </Grid>
                </Grid>

                <Grid sx={{ mt: 2 }}>
                  <div style={{ fontSize: 12 }}>{product?.description}</div>
                </Grid>
              </Grid>
            );
          })
        ) : (
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 20,
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: 25 }}>
              No Services Found
            </Typography>
          </Grid>
        )}
      </React.Fragment>
    );
  };

  const ServiceItem = ({ offerList }) => {
    return (
      <>
        {offerList?.length > 0 ? (
          offerList?.map((item, index) => {
            return (
              <Grid
                key={index + 1}
                item
                xs={12}
                sm={3}
                xl={2}
                sx={{
                  boxShadow: 2,
                  borderRadius: 2,
                  p: 1,
                }}
              >
                <Grid sx={{ height: "20vh" }}>
                  <Box
                    component="img"
                    sx={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                      borderRadius: 1,
                    }}
                    alt="5k Car Care"
                    src={
                      item?.service_image ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdaOuISNPK0h-pbCWSRXVlLG6YrOr4MdXanw&s"
                    }
                  />
                </Grid>

                <Grid
                  sx={{
                    mt: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Grid sx={{ display: "flex", alignItems: "center" }}>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        textDecoration: "line-through",
                      }}
                    >
                      <CurrencyRupeeIcon fontSize="xs" />
                      <Typography sx={{ fontSize: 12 }}>
                        {item?.price || "0"}
                      </Typography>
                    </Grid>

                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CurrencyRupeeIcon fontSize="xs" sx={{ fontSize: 16 }} />
                      <Typography sx={{ fontSize: 16 }}>
                        {item?.discounted_price || 0}
                      </Typography>
                    </Grid>
                  </Grid>
                  {/* For Desktop */}
                  <Grid sx={{ display: { xs: "none", lg: "block" } }}>
                    <Typography
                      noWrap={false}
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: {
                          xs: 2,
                          md: 1,
                        } /* number of lines */,
                        WebkitBoxOrient: "vertical",
                        fontWeight: "bold",
                      }}
                    >
                      <Tooltip title={item?.name} arrow>
                        {/* {item?.name?.length > 20 ? (
                          `${item?.name.substring(0, 20)}...`
                        ) : item?.name ? (
                          item?.name
                        ) : (
                          <Skeleton width={80} />
                        )} */}

                        {(() => {
                          if (!item?.name) {
                            return <Skeleton width={80} />;
                          }
                          return item?.name?.length > 20
                            ? `${item?.name.substring(0, 20)}...`
                            : item?.name;
                        })()}
                      </Tooltip>
                    </Typography>
                  </Grid>
                  {/* For Mobile */}

                  <Grid sx={{ display: { xs: "block", lg: "none" } }}>
                    <Typography
                      noWrap={false}
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: {
                          xs: 2,
                          md: 1,
                        } /* number of lines */,
                        WebkitBoxOrient: "vertical",
                        fontWeight: "bold",
                      }}
                    >
                      {item?.name?.length > 14 ? (
                        `${item?.name.substring(0, 14)}...`
                      ) : item?.name ? (
                        item?.name
                      ) : (
                        <Skeleton width={80} />
                      )}
                    </Typography>
                  </Grid>
                  {/* Slot & Rating */}
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography sx={{ pt: 0.5, fontSize: 14 }}>
                        {item?.rating || 5}
                      </Typography>
                      <Rating
                        name="half-rating-read"
                        precision={0.5}
                        value={item?.rating || 5}
                        readOnly
                        size="small"
                      />
                    </Grid>
                    <Typography
                      sx={{ fontSize: 14 }}
                    >{`${item?.slot_time} mins`}</Typography>
                  </Grid>
                </Grid>

                <Grid sx={{ mt: 2 }}>
                  <div style={{ fontSize: 12 }}>{item?.description}</div>
                </Grid>
              </Grid>
            );
          })
        ) : (
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 20,
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: 25 }}>
              No Services Found
            </Typography>
          </Grid>
        )}
      </>
    );
  };

  const Footer = ({ itemList, offerAmount, amount, type, applied }) => {
    return (
      <>
        {applied ? (
          itemList?.length > 0 && (
            <Grid
              container
              sx={{
                mt: 3,
                position: "fixed",
                bottom: { xs: 10, sm: 30 },
                // pr: 2,
                alignSelf: "center",
              }}
            >
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", sm: "flex-end" },
                  alignItems: "center",
                  gap: { sm: 10, xs: 3 },
                  background: "#DDDFF590",
                  width: "93.5%",
                  p: 2,
                  borderRadius: 2,
                }}
              >
                <Typography>Qty: {itemList?.length}</Typography>
                {itemList?.length > 0 && itemList[0]?.type !== "amcService" && (
                  <Grid sx={{ display: "flex", alignItems: "center" }}>
                    <CurrencyRupeeIcon fontSize="xs" />
                    <Typography>
                      {Number(offerAmount || amount)?.toFixed(2)}
                    </Typography>
                  </Grid>
                )}

                <Button
                  size="small"
                  variant="contained"
                  sx={{
                    background: "#071CB7",
                    textTransform: "capitalize",
                  }}
                  onClick={() => handleNavigation(type)}
                  disabled={itemList?.length == 0}
                >
                  Proceed To Buy
                </Button>
              </Grid>
            </Grid>
          )
        ) : (
          <Grid
            container
            sx={{
              mt: 3,
              position: "fixed",
              bottom: { xs: 10, sm: 30 },
              // pr: 2,
              alignSelf: "center",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-end" },
                alignItems: "center",
                gap: { sm: 10, xs: 3 },
                background: "#DDDFF590",
                width: "93.5%",
                p: 2,
                borderRadius: 2,
              }}
            >
              <Button
                size="small"
                variant="contained"
                sx={{
                  background: "#071CB7",
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  if (!signIn) {
                    setOpenSignin(true);
                    return;
                  }
                  type === "Product" ? cartValidate() : serviceCartValidate();
                }}
                disabled={cartLoad}
              >
                Add to Cart
              </Button>
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  /* APIs */

  const getCartList = async () => {
    try {
      return global.$axios.get(`cart/listCart/${global.$userData.id}`);
    } catch (error) {
      console.log("Service Cart List Issue(website offer page)", error);
    }
  };

  const getProductCartList = async () => {
    try {
      return global.$axios.get(`product/listCart/${global.$userData.id}`);
    } catch (error) {
      console.log("Product Cart List Issue(website offer page)", error);
    }
  };

  const findMatch = async (data) => {
    try {
      const response =
        data?.type === "Service"
          ? await getCartList()
          : await getProductCartList();

      console.log("res", response.data);

      if (response.data.status === "success") {
        const matches = response.data.message?.find(
          (e) => data?.name === e?.special_offer_id?.name
        );
        if (matches) {
          setApplied(true);
        } else {
          setApplied(false);
        }
      } else {
        console.log("Cart List Fetch View Offer Service", response.data);
      }
    } catch (error) {
      console.log("Website offer find match issue", error);
    }
  };

  /* get offer details */
  useEffect(() => {
    const fetchCouponDetails = async () => {
      setLoader(true);
      try {
        const payload = {
          name: get_id,
          branch_id: branchValue?._id || null,
          car_size_id: carValue?.size_id?._id
            ? carValue?.size_id?._id
            : carValue?.size_id || null,
          customer_id: global.$userData?.id || null,
        };

        const { data } = await global.$axios.post(
          "dashboard/websiteCouponView",
          payload
        );
        if (data.status === "success") {
          setOfferList(data.message);
          setCouponDetails(data?.specialOffer);
          if (data?.specialOffer?.type !== "AMC" && signIn) {
            await findMatch(data?.specialOffer);
          }
        } else {
          console.error("Website Coupon Detail Issue", data);
          setOfferList([]);
          setCouponDetails(null);
        }
      } catch (error) {
        console.error("Website Coupon Detail Issue", error);
        setOfferList([]);
        setCouponDetails(null);
      } finally {
        setLoader(false);
      }
    };

    fetchCouponDetails();
  }, [branchValue, get_id, carValue]);

  useEffect(() => {
    if (!signIn) {
      dispatch(LastURL(window.location.toString().split("#")[1]));
    }
  }, []);

  return (
    <div style={{ margin: "15px 15px" }}>
      <Grid sx={{ p: { sm: 2, xs: 1 }, mt: { xs: 22, sm: 2 } }}>
        {loader ? (
          <>
            <SkeletonLoader />
            <SkeletonLoader />
          </>
        ) : (
          <Grid container sx={{ gap: 5, mb: 10 }}>
            <Grid
              container
              item
              sx={{
                mt: { md: 3, xs: 25 },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ fontSize: { sm: 25, xs: 20 }, fontWeight: 700 }}
              >
                {couponDetails?.name || "Offers"}
              </Typography>
            </Grid>
            {(() => {
              let content = null;
              if (couponDetails?.type === "AMC") {
                content = <AMCItem offerList={offerList} />;
              } else if (couponDetails?.type === "Product") {
                content = <ProductItem offerList={offerList} />;
              } else content = <ServiceItem offerList={offerList} />;
              return content;
            })()}
          </Grid>
        )}
      </Grid>

      {offerList?.length > 0 && couponDetails?.type !== "AMC" && (
        <Footer
          itemList={
            couponDetails?.type === "Service" ? cartList : productCartList
          }
          offerAmount={
            couponDetails?.type === "Service" ? offerTotal : productOfferTotal
          }
          amount={couponDetails?.type === "Service" ? total : productTotal}
          type={couponDetails?.type}
          applied={applied}
        />
      )}

      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}

      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}

      {openCartConfirm && (
        <CartConfirmation
          openCartConfirm={openCartConfirm}
          setOpenCartConfirm={setOpenCartConfirm}
          addFunction={addFunction}
          selectedService={selectedService}
        />
      )}

      {openSignin && (
        <SigninPop openSignin={openSignin} setOpenSignin={setOpenSignin} />
      )}

      {openAddCar && (
        <AddCar openAddCar={openAddCar} setOpenAddCar={setOpenAddCar} />
      )}
    </div>
  );
};

export default WebsiteOffer;
